import PropTypes from 'prop-types';
import { trans, getResourcePath } from '@spotahome/soyuz/client';

import './NotFound.scss';

const NotFound = props => {
  return (
    <section className="not-found__section">
      <h1 className="not-found__header">{trans('error_page.not_found.h1')}</h1>
      <img
        className="not-found__image"
        src={getResourcePath('/images/show-rentable-unit/404-door.svg')}
        alt={trans('error_page.not_found.content')}
      />
      <p className="not-found__content">
        {trans('error_page.not_found.content')}
      </p>
      <a
        href={props.exploreButtonHref}
        className="button not-found__back-to-results"
        title={trans('error_page.not_found.back_button')}
      >
        <span>{trans('error_page.not_found.back_button')}</span>
      </a>
    </section>
  );
};

NotFound.propTypes = {
  exploreButtonHref: PropTypes.string.isRequired
};

export default NotFound;
